import { Injectable } from '@angular/core';
import { ToastController, Toast } from 'ionic-angular';

@Injectable()
export class ToasterProvider {
  toast: Toast;

  constructor(public toastCtrl: ToastController) {}

  public createToast(options: object): Toast {
    return this.toastCtrl.create(options);
  }

  public showError(message: string, duration?: number): Promise<any> {
    this.toast = this.createToast({
      message: message,
      cssClass: 'red-toast',
      duration: duration | 2000
    });
    return this.toast.present();
  }

  public showInfo(message: string, duration?: number): Promise<any> {
    this.toast = this.createToast({
      message: message,
      duration: duration | 2000
    });
    return this.toast.present();
  }
}
